import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Dish } from 'types';

interface DishSatelliteConnections {
  dish_id: number;
  satellite_ids: number[];
}

export const updateSatelliteConnections = (
  data: DishSatelliteConnections
): Promise<Dish> => {
  return axios.post(
    `/api/dishes/${data.dish_id}/satellite`,
    data.satellite_ids
  );
};

type UseUpdateSatelliteConnectionOptions = {
  config?: MutationConfig<typeof updateSatelliteConnections>;
};

export const useUpdateSatelliteConnections = ({
  config,
}: UseUpdateSatelliteConnectionOptions) => {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['dishes']);
      queryClient.invalidateQueries(['satellites']);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: updateSatelliteConnections,
  });
};
